import { Outlet, createFileRoute } from "@tanstack/react-router";

import { DEMO_IDS } from "@/mock/demo";
import { Header } from "@/components/ui/header";
import { Navigation } from "./-ui.navigation";
import { OnboardingWidget } from "@/components/Generic/OnboardingWidget";
import { TermsAcknowledgmentDialog } from "@/components/ui/TermsAcknowledgmentDialog";
import { api } from "@cvx/_generated/api";
import { convexQuery } from "@convex-dev/react-query";
import { useAccount } from "@/state/useAccount";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useTermsAcknowledgment } from "@/hooks";

export const Route = createFileRoute("/_app/_auth/dashboard/_layout")({
  component: DashboardLayout,
});

function DashboardLayout() {
  const { data: user } = useQuery(convexQuery(api.app.getCurrentUser, {}));
  const { appId, setAppId, demoModeEnabled } = useAccount();
  const { shouldShowPopup, markAsAcknowledged } = useTermsAcknowledgment();

  useEffect(() => {
    // Don't reset appId if we're in demo mode with the demo app
    const isDemoApp =
      demoModeEnabled &&
      (appId as unknown as string) === (DEMO_IDS.appId as unknown as string);

    if (
      appId &&
      !isDemoApp &&
      user &&
      user.appsList.length > 0 &&
      !user?.appsList.some((app) => app._id === appId)
    ) {
      setAppId(user.appsList[0]._id);
    }
  }, [user, appId, setAppId, demoModeEnabled]);

  if (!user) {
    return null;
  }

  return (
    <div className="flex min-h-[100vh] w-full flex-col bg-secondary dark:bg-black">
      <Navigation user={user} />
      <Header user={user} />
      <Outlet />
      <OnboardingWidget />
      <TermsAcknowledgmentDialog
        open={shouldShowPopup}
        onClose={markAsAcknowledged}
      />
    </div>
  );
}
